import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { ConsignorService } from '../../_services/_masters/consignor.service';
import { Subject } from 'rxjs';
import 'rxjs/add/operator/map';
import { Http, Response } from '@angular/http';
import { environment } from '../../../environments/environment';
// import * as $ from 'jquery';
declare var $ : any;
import swal from 'sweetalert2';
import { DataTableDirective } from 'angular-datatables';

import { SelectablesService } from '../../selectables.service';


class ConsignorForm {
	consignor_name:string;
	address : string;
	branch: string;
	inv_prefix: string;
	handling: string;
	freight_by: string;
	loading: string;
	contact_no: string;
	
}

@Component({
	selector: 'app-consignor',
	templateUrl: './consignor.component.html',
	styleUrls: ['./consignor.component.css']
})

export class ConsignorComponent implements OnInit {

	consignorForm : FormGroup;
	modalConsignorForm : FormGroup;
	modalData : any;
	check_branch: boolean = true;

	// Data Table Configurations
	dtOptions: any = {};
	dataTable: any;
	dtTrigger: Subject<any> = new Subject();
	consignor_form: ConsignorForm[] = [];

	stations : string[] = [];
	currentUser  : any ;
	token : any ;
	user_role : string = null ;
	user_branch : string = null ;

	url = environment.url;
	@ViewChild(DataTableDirective)
	dtElement: DataTableDirective;

	query : any = null;
	response : any = null;

	constructor( private consignorService : ConsignorService,
				private selectBranchService : SelectablesService,
				private http: Http) { }

	ngOnInit() 
	{

		this.consignorForm = new FormGroup({
			'consignor_name': new FormControl(null , Validators.required),
			'address': new FormControl(null , Validators.required),
			'branch': new FormControl(null , Validators.required),
			'contact_no': new FormControl(null , Validators.required),
			'inv_prefix': new FormControl(null , Validators.required),
			'loading': new FormControl(null , Validators.required),
			'handling': new FormControl(null , Validators.required),
			'freight_by': new FormControl(null , Validators.required),
			"recipients" : new FormArray([])
		});
		this.consignorForm.patchValue({
			'branch': this.user_branch
		});

		this.addRecipient();

		this.modalConsignorForm = new FormGroup({
			'consignor_name': new FormControl(null , Validators.required),
			'address': new FormControl(null , Validators.required),
			'branch': new FormControl(null , Validators.required),
			'contact_no': new FormControl(null , Validators.required),
			'inv_prefix': new FormControl(null , Validators.required),
			'loading': new FormControl(null , Validators.required),
			'handling': new FormControl(null , Validators.required),
			'freight_by': new FormControl(null , Validators.required),
			"recipients" : new FormArray([])
		});


		this.dtOptions = {
			pagingType: 'full_numbers',
			pageLength: 5,
			responsive: true,
			// select:true,
			rowCallback: (row: Node, data: any[] | Object, index: number) => {
				const self = this;
				// Unbind first in order to avoid any duplicate handler
				// (see https://github.com/l-lin/angular-datatables/issues/87)
				$('td', row).unbind('click');
				$('td', row).bind('click', () => {
					self.someClickHandler(data);
				});
				return row;
			},
			dom: 'Bfrtip',
			// Configure the buttons
			buttons: [
				// 'columnsToggle',
				'colvis',
				'copy',
				'print',
				'excel'
			]
		};

		this.http.get(this.url + '/masters/consignor/all')
		// this.http.get('http://backendtransport.iogreen.in/masters/consignor/all')
			.map(this.extractData)
			.subscribe(forms => {
				this.consignor_form = forms;
				console.log(this.consignor_form);
				// Calling the DT trigger to manually render the table
				this.dtTrigger.next();
			});

		var myObject = localStorage.getItem('currentUser');
		var temp = JSON.parse(myObject);	
		if(localStorage.getItem('currentUser'))
		{
			if (temp["role"] === 'Admin')
			{
				this.getBranch();
				this.check_branch = false;
			}
			else if(temp['role'] === 'Manager' || temp['role'] === 'Employee')
			{
				this.consignorForm.get('branch').setValue(temp['branch']);
				this.stations.push(temp['branch']);
				this.check_branch = true;
			}
		}

	}
	
	private extractData(res: Response) {
		const body = res.json();
		console.log(body.data || {});
		return body;

	};

	someClickHandler(info: any): void {
		this.consignorService.getConsignorFormWith(info[0].toString().replace(/&amp;/g, '&').replace(/%20/g, ' '))
		.subscribe(response => {
			this.modalData = JSON.stringify(response)
			this.modalData =JSON.parse(this.modalData)
			this.modalConsignorForm.patchValue({
				"consignor_name": this.modalData[0].consignor_name,
				"loading": this.modalData[0].loading,
				"handling": this.modalData[0].handling,
				'branch': this.modalData[0].branch,
				"contact_no": this.modalData[0].contact_no,
				"inv_prefix": this.modalData[0].inv_prefix,
				"freight_by": this.modalData[0].freight_by,
				"address": this.modalData[0].address,
				"recipients" : []
			});
			this.removeAllRecipientsForModal();
			
			var  control : any = [];
			for (var email in this.modalData[0].recipients){
				console.log(this.modalData[0].recipients);
				control = new FormControl(this.modalData[0].recipients[email], Validators.required);
			(<FormArray>this.modalConsignorForm.get("recipients")).push(control);
			}
		});	
		$("#default-modal").modal('show');
	};
	getBranch()
	{
		this.selectBranchService.getBranches()
		.subscribe(
			branches => {
				for(var i=0;i<branches.length;i++)
				{
					this.stations.push(branches[i]['branch_name']);
				}
			});
	}
	submit()
	{
		console.log(this.consignorForm.value);
		//this.consignorService.addNewConsignor(this.consignorForm.value)
		//.subscribe(response => console.log(response)
		this.removeEmptyRecipient();
		this.consignorService.addNewConsignor(this.consignorForm.value)
		.subscribe(response => 
		{
			
			if(response['status'])
			{
				swal('Save', 'Record save successfully', 'success');
				this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => 
				{
					dtInstance.destroy();
					this.http.get(this.url + '/masters/consignor/all')
						.map(this.extractData)
						.subscribe(forms => 
						{
							this.consignor_form = forms;
							console.log(this.consignor_form);
							// Calling the DT trigger to manually render the table
							this.dtTrigger.next();
						});
				});
				
			}
			else
			{
				swal('Oops!', 'Something went wrong on the page! <br />'+ response['message'], 'error');
			}
		});

	};

	updateConsignor(){
		console.log(this.modalConsignorForm.value);
		console.log(this.modalData);

		this.query={
			"consignor_oid" : this.modalData[0]._id,
			"consignor_data" : this.modalConsignorForm.value
		}

		console.log(this.query);

		this.http.post( this.url + "/masters/consignor/update", this.query)
		.subscribe(res => { 
			console.log(res.json());
			this.response = res.json();
			console.log(this.response.status);
			if (this.response.status){

				if (this.response.message === 'Consignor Updated Successfully'){
					swal(
						'Success',
						'Consignor Form Updated Successfully',
						'success'
					);
					this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => 
					{
						dtInstance.destroy();
						this.http.get(this.url + '/masters/consignor/all')
							.map(this.extractData)
							.subscribe(forms => 
							{
								this.consignor_form = forms;
								console.log(this.consignor_form);
								// Calling the DT trigger to manually render the table
								this.dtTrigger.next();
							});
					});
				}

				if (this.response.message === 'Consignor Information not Changed'){
					swal(
						'Info',
						'Consignor information not changed',
						'info'
					);
				}
			}
			else{
				swal(
					'Unknown Error',
					'Please Refresh your page',
					'error'
				);
			}
			
		});
	};

	// DELETE CONSIGNOR
	deleteConsignor(){
		console.log("Hello");
		this.query={
			"consignor_id" : this.modalData[0]._id.$oid,
			"branch": this.modalData[0].branch
		}

		console.log(this.query);
		swal({
			title: 'Are you sure?',
			text: 'You want to delete Consignor',
			type: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'No, keep it'
		}).then((result) => {
			if (result.value) {
			
				this.http.post(this.url + '/masters/consignor/delete', this.query)
				.map(response => response.json())
				.subscribe(
					(response)=>{
						console.log(response);
						if (response["status"]){
							console.log(response);
							console.log("success");
							swal('Deleted!','Your Consignor has been deleted.','success');
							this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => 
							{
								dtInstance.destroy();
								this.http.get(this.url + '/masters/consignor/all')
								.map(this.extractData)
								.subscribe(forms => 
								{
									this.consignor_form = forms;
									console.log(this.consignor_form);
									// Calling the DT trigger to manually render the table
									this.dtTrigger.next();
								});
							});

							$("#default-modal").modal("hide");
							
						}else{
							swal("error","Oops , Somthing went wrong, Consignor is not deleted","error");
						}
					},
					(error)=>console.log(error.json())
					);
			} 
			
		})
	}

	// END

	addRecipient(){
		const control = new FormControl(null, Validators.required);
		(<FormArray>this.consignorForm.get("recipients")).push(control);
	}
	deleteRecipient(){
		const control = <FormArray>this.consignorForm.controls['recipients'];
		control.removeAt(-1);
	}

	removeAllRecipientsForModal(){
		const control = <FormArray>this.modalConsignorForm.controls['recipients'];
		while (control.length !== 0) {
			control.removeAt(0)
		}
	}

	removeEmptyRecipient(){
		const control = <FormArray>this.consignorForm.controls['recipients'];
		var i = 0;
		while (control.length !== i) {
			console.log(control.value[i]);
			if(control.value[i] == null){
				control.removeAt(i);
				i = 0
			}
			else{
				i+=1;
			}
			
		}
	}

	addModalRecipient(){
		const control = new FormControl(null, Validators.required);
		(<FormArray>this.modalConsignorForm.get("recipients")).push(control);
	}
	deleteModalRecipient(){
		const control = <FormArray>this.modalConsignorForm.controls['recipients'];
		control.removeAt(-1);
	}

}



// WEBPACK FOOTER //
// /Users/meghneel/work/shree_translogic_dashboard/src/app/masters/consignor/consignor.component.ts